import LoadingIcon from "../../../assets/icons/loading.gif";

const LoadingButton = ({
  color,
  disabled,
  type,
  title,
  loading,
  width,
  textColor,
}: {
  color?: string;
  disabled: boolean;
  title: string;
  type: string;
  loading?: boolean;
  width?: string;
  textColor?: string;
}) => {
  return (
    <button
      //@ts-ignore
      type={type}
      className={`btn btn-primary ${width ? width : "w-full"} bg-${
        color ? color : "pr_primary"
      } ${color ? `border-${color}` : `border-pr_primary`} text-${
        textColor ? textColor : "white"
      }`}
      disabled={disabled}
    >
      {loading ? (
        <img src={LoadingIcon} width={35} height={35} alt="بارگذاری" />
      ) : (
        title
      )}
    </button>
  );
};

export default LoadingButton;
